import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useTheme, styled } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useNavigate } from "react-router-dom";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { useTranslation } from "react-i18next";
import VehicleInfos from "../../../_components/steps/VehicleInfos";
import VerifiedIcon from "@mui/icons-material/Verified";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import DirectionsCarFilledIcon from "@mui/icons-material/DirectionsCarFilled";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import Cookies from "universal-cookie";
import { LifeSafer } from "../../../_helpers/BrandConstants";
import Link from "@mui/material/Link";
import HistoryIcon from "@mui/icons-material/History";
import { brandColors } from "../../../_components/brandedComponent/BrandedColors";
import ContactInfo from "../../../_components/steps/ContactInfo";
import ViolationInfo from "../../../_components/steps/ViolationInfo";
import {
  saveNewVehicle,
  loadVehicle,
} from "../../../_redux/actions/vehicleActions";
import { connect } from "react-redux";
import {
  registerEnrollee,
  enrolleeUpdate,
  saveEnrollee,
  clientUpdate,
  loadEnrollee,
  generatePriceQuote,
  GetQuietHours,
} from "../../../_redux/actions/enrolleeActions";
import { useToaster } from "../../../_components/toaster/MuiToasterProvider";
import { useForm } from "react-hook-form";
import { utilities } from "@/_helpers";
import PricingTextPilotLocationStep from "./PricingTextPilotLocationStep";
import { GridLoader } from "react-spinners";
import ReferralModal from "../../../_components/steps/modal/ReferralModal";
import ChatBotIcon from "../../../_components/steps/ChatBody/ChatBotIcon";

const ColorlibConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    backgroundImage:
      "linear-gradient(136deg, rgb(72,113,34) 0%, rgb(118,188,33) 50%, rgb(84,195,97) 100%)",
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    backgroundImage:
      "linear-gradient(136deg, rgb(72,113,34) 0%, rgb(118,188,33) 50%, rgb(84,195,97) 100%)",
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled("div")(({ ownerState }) => ({
  backgroundColor: "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 40,
  height: 40,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundImage:
      "linear-gradient(136deg, rgb(72,113,34) 0%, rgb(118,188,33) 50%, rgb(84,195,97) 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    backgroundImage:
      "linear-gradient(136deg, rgb(72,113,34) 0%, rgb(118,188,33) 50%, rgb(84,195,97) 100%)",
  }),
}));

const StepperText = styled("div")({
  display: "flex",
  justifyContent: "center",
});

function ColorlibStepIcon(props) {
  const { active, completed, icon } = props;

  const icons = {
    1: <EmojiPeopleIcon />,
    2: <PersonSearchIcon />,
    3: <FindInPageIcon />,
    4: <DirectionsCarFilledIcon />,
    5: <ReceiptLongIcon />,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ active, completed }}>
      {icons[String(icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

const QuietHours = ({
  setOpenChatBot,
  openChatBot,
  pereferedContact,
  QuietHoursInstruction,
  enrolleeUser,
  showGetExpertIcon,
}) => {
  const quiteData = useMemo(() => {
    if (pereferedContact?.toLowerCase() === "phone") {
      return QuietHoursInstruction?.find(
        (x) => x?.type?.toLowerCase() === "phone",
      );
    } else {
      const quiteDataFilter =
        QuietHoursInstruction?.filter(
          (x) => x?.type?.toLowerCase() === "text",
        ) || [];

      if (quiteDataFilter.length > 0) {
        const clientId = enrolleeUser?.clientId || enrolleeUser?.ClientId;
        const hasValidClientId = Number.isFinite(Number(clientId));
        const showIndex =
          hasValidClientId && Number(clientId) % 2 !== 0 ? 1 : 0;
        return quiteDataFilter[showIndex] || quiteDataFilter[0];
      }
    }

    return null;
  }, [pereferedContact, QuietHoursInstruction, enrolleeUser]);

  return (
    <>
      <Grid
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          gap: 3,
          mt: 3,
        }}
      >
        <Grid
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            gap: "2px",
          }}
        >
          <Box sx={{ position: "relative", display: "inline-block" }}>
            <VerifiedIcon
              sx={{
                fontSize: "60px",
                color: "#76BC21",
                position: "absolute",
                top: 0,
                left: 0,
                clipPath: "inset(0 50% 0 0)",
              }}
            />

            <VerifiedIcon
              sx={{
                fontSize: "60px",
                color: "#60A110",
                clipPath: "inset(0 0 0 50%)",
              }}
            />
          </Box>

          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "18px",
              // color: "#1c355e",
              color: "black",
              textAlign: "center",
              mt: 1,
              width: {
                xs: "98%",
                md: "40%",
              },
            }}
          >
            {quiteData?.title}
          </Typography>
          <Typography
            sx={{
              width: {
                xs: "97%",
                md: "50%",
              },
              mt: 1,
              textAlign: "center",
            }}
          >
            {quiteData?.description1}
          </Typography>

          <Typography
            sx={{
              width: {
                xs: "92%",
                md: "45%",
              },
              mt: 1,
              textAlign: "center",
            }}
          >
            {quiteData?.description2}
          </Typography>
        </Grid>
        <Grid>
          <Button
            type="submit"
            // size="small"
            variant="contained"
            style={{
              height: 35,
              // width: "max-content",
              marginTop: "14px",
              marginBottom: "20px",
              paddingLeft: "24px",
              paddingRight: "24px",
              fontWeight: "bold",
              backgroundColor: "#76BC21",
              color: "#1C355E",
            }}
            component={quiteData?.type === "text" ? "button" : "a"}
            href={
              quiteData?.type === "text"
                ? undefined
                : `tel:${quiteData?.phoneNumber}`
            }
            onClick={quiteData?.clickEvent}
          >
            {quiteData?.buttonText}
          </Button>
        </Grid>
      </Grid>
      {(quiteData?.showChatBot || openChatBot) && (
        <ChatBotIcon
          setOpen={setOpenChatBot}
          open={openChatBot}
          showGetExpertIcon={showGetExpertIcon}
        />
      )}
    </>
  );
};

QuietHours.propTypes = {
  setOpenChatBot: PropTypes.func,
  openChatBot: PropTypes.object,
  pereferedContact: PropTypes.string,
  QuietHoursInstruction: PropTypes.Array,
  enrolleeUser: PropTypes.object,
  t: PropTypes.func,
  showGetExpertIcon: PropTypes.object,
};

const PricingStory = ({
  referralSiteData,
  registerEnrollee,
  enrolleeUpdate,
  saveEnrollee,
  clientUpdate,
  steps,
  activeStep,
  setActiveStep,
  stepLabels,
  saveNewVehicle,
  loadEnrollee,
  hasSetInitialStep,
  loadVehicle,
  setDeviceNeeded,
  setShowVehicleStep,
  phoneNumber,
  isLoaded,
  generatePriceQuote,
  GetQuietHours,
}) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [secondsLeft, setSecondsLeft] = useState(300);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const orientation = isMobile ? "vertical" : "horizontal";
  const [startTime, setStartTime] = useState(null);
  const cookies = new Cookies();
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const jwtTokenData = cookies.get("lifesaferEnrollment");
  const [submitting, setSubmitting] = useState(false);
  const enrolleeUser = JSON.parse(sessionStorage.getItem("enrolleeUser"));
  const buildQuoteStep = JSON.parse(sessionStorage.getItem("buildQuoteStep"));

  const toast = useToaster();
  const enrollmentCodeData = cookies.get("lsEnrollmentCode");
  let clientSaveResponse = null;
  // const deviceType = localStorage.getItem("devicetype");
  const [pereferedContact, setPreferedContact] = useState(
    enrolleeUser?.contactPreference || "Phone",
  );
  const [isEnrolleeLoadNeeded, setIsEnrolleeLoadNeeded] = useState(false);
  const EnrollCookieData = cookies.get("EnrollNow") || {};
  let shouldSkipNextStep = false;
  const [openChatBot, setOpenChatBot] = useState(false);
  const [showGetExpertIcon, setShowGetExpertIcon] = useState(true);
  const [showGeneratingQuoteMessage, setShowGeneratingQuoteMessage] =
    useState(false);

  const [showQuietHours, setShowQuietHours] = useState(false);
  const [pilotLocation, setPilotLocation] = useState(null);

  const isISA =
    enrolleeUser?.clientTypeId === 6 ||
    enrolleeUser?.deviceType?.toLowerCase() === "speed" ||
    enrolleeUser?.deviceType?.toLowerCase() === "isa";
  const isPAM =
    enrolleeUser?.clientTypeId === 5 ||
    enrolleeUser?.deviceType?.toLowerCase() === "portable" ||
    enrolleeUser?.deviceType?.toLowerCase() === "pam";
  const resolvedClientId = enrolleeUser?.clientId || enrolleeUser?.ClientId;
  const hasJwtToken = Boolean(jwtTokenData?.jwtToken);
  const clientLastDigit = String(resolvedClientId || "").slice(-1);
  const isEvenClientId =
    /^[0-9]$/.test(clientLastDigit) && Number(clientLastDigit) % 2 === 0;
  const isTextPreference =
    (pereferedContact || enrolleeUser?.contactPreference || "")
      .toLowerCase()
      .trim() === "text";
  const usePricingTextPilot = isTextPreference && isEvenClientId;
  const [isPilotQuoteReady, setIsPilotQuoteReady] = useState(
    Boolean(
      sessionStorage.getItem("pricingTextPilotQuoteReady") === "1" &&
      sessionStorage.getItem("pricingTextPilotClientId") ===
        String(resolvedClientId || ""),
    ),
  );


  const resolveClientDeviceType = (clientTypeId) => {
    const normalizedClientTypeId = Number(clientTypeId);
    if (!Number.isFinite(normalizedClientTypeId)) return null;
    if (normalizedClientTypeId === 5) return "Portable";
    if (normalizedClientTypeId === 6) return "Speed";
    if (normalizedClientTypeId === 1) return "Interlock";
    return null;
  };

  const normalizeDeviceTypeCandidate = (deviceCandidate) => {
    if (
      deviceCandidate === null ||
      deviceCandidate === undefined ||
      deviceCandidate === ""
    ) {
      return null;
    }

    if (typeof deviceCandidate === "number") {
      return resolveClientDeviceType(deviceCandidate);
    }

    if (typeof deviceCandidate === "string") {
      const trimmedValue = deviceCandidate.trim();
      if (!trimmedValue) return null;
      if (/^\d+$/.test(trimmedValue)) {
        return resolveClientDeviceType(Number(trimmedValue));
      }

      const normalizedDeviceType =
        utilities?.deviceInfo(trimmedValue)?.deviceType;
      return normalizedDeviceType || null;
    }

    return null;
  };

  const resolveDeviceTypeValue = (...deviceCandidates) => {
    for (const deviceCandidate of deviceCandidates) {
      const normalizedDeviceType =
        normalizeDeviceTypeCandidate(deviceCandidate);
      if (normalizedDeviceType) {
        return normalizedDeviceType;
      }
    }

    return null;
  };

  const getClientTypeIdFromSessionData = (sessionData = {}) => {
    const clientTypeIdCandidate =
      sessionData?.clientTypeId ??
      sessionData?.ClientTypeId ??
      sessionData?.clientTypeID ??
      sessionData?.ClientTypeID;
    const normalizedClientTypeId = Number(clientTypeIdCandidate);
    return Number.isFinite(normalizedClientTypeId)
      ? normalizedClientTypeId
      : null;
  };

  const setEnrolleeUserSession = (sessionData = {}) => {
    const normalizedClientTypeId = getClientTypeIdFromSessionData(sessionData);
    const normalizedSessionData =
      normalizedClientTypeId === 6
        ? {
            ...sessionData,
            deviceType: "Speed",
          }
        : normalizedClientTypeId === 5
          ? {
              ...sessionData,
              deviceType: "Portable",
            }
          : normalizedClientTypeId === 1
            ? {
                ...sessionData,
                deviceType: "Interlock",
              }
            : sessionData;

    sessionStorage.setItem(
      "enrolleeUser",
      JSON.stringify(
        utilities.normalizeEnrolleeSessionData(normalizedSessionData),
      ),
    );
  };

  const STEPS = {
    DEVICE: "DEVICE",
    LOCATION_MAP: "LOCATION_MAP",
    LOCATION_ZIP: "LOCATION_ZIP",
    DATE_TIME: "DATE_TIME",
    SCHEDULE_NOW: "SCHEDULE_NOW",
  };
  const [, setStepSchedule] = useState(STEPS.SCHEDULE_NOW);
  const [, setFlagDevice] = useState(false);
  const [referralModal, setReferralModal] = useState(false);

  const handleReferalSubmit = () => {
    const storedEnrolleeUser =
      JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
    const { isReferralModalSubmit, ...cleanEnrolleeUser } = storedEnrolleeUser;

    if (isReferralModalSubmit) {
      setEnrolleeUserSession(cleanEnrolleeUser);
    }

    setReferralModal(false);
    goToNextStep();
  };

  const loadQuietHours = async () => {
    if (!resolvedClientId || !hasJwtToken) {
      return;
    }

    try {
      const res = await GetQuietHours(resolvedClientId);
      let quietHoursData = {
        ...res,
        showGeneratingQuoteMessage: res?.isQuiteHours,
      };
      setEnrolleeUserSession({
        ...enrolleeUser,
        ...quietHoursData,
      });
      setShowQuietHours(Boolean(res?.isQuiteHours));
      setShowGeneratingQuoteMessage(Boolean(res?.isQuiteHours));
    } catch (error) {
      console.error("Failed to load quiet hours", error);
      setShowQuietHours(false);
    }
  };

  const stateInfoStepIndex = useMemo(
    () => steps.findIndex((step) => step === "Violation"),
    [steps],
  );

  useEffect(() => {
    const hasReachedStateInfoStep =
      stateInfoStepIndex >= 0 && activeStep >= stateInfoStepIndex;

    if (!resolvedClientId || !hasJwtToken || !hasReachedStateInfoStep) {
      return;
    }

    loadQuietHours();
  }, [
    activeStep,
    resolvedClientId,
    hasJwtToken,
    stateInfoStepIndex,
    enrolleeUser?.isQuiteHours,
  ]);

  // const handleViewMyQuote = async () => {
  //   const clientId = enrolleeUser?.clientId || enrolleeUser?.ClientId;
  //   const vehicleId =
  //     enrolleeUser?.vehicleId ||
  //     enrolleeUser?.VehicleId ||
  //     enrolleeUser?.selectedVehicleID ||
  //     null;

  //   const normalizedDeviceType =
  //     enrolleeUser?.deviceType === "Portable" ||
  //     enrolleeUser?.clientTypeId === 5
  //       ? "PAM"
  //       : enrolleeUser?.deviceType === "Speed" ||
  //           enrolleeUser?.deviceType === "ISA" ||
  //           enrolleeUser?.clientTypeId === 6
  //         ? "ISA"
  //         : "IID";

  //   try {
  //     let priceQuoteRes = await generatePriceQuote({
  //       ClientID: clientId,
  //       VehicleID: vehicleId,
  //       DeviceType: normalizedDeviceType,
  //       LocationID: pilotLocation?.locationID,
  //       ContactMethod:
  //         enrolleeUser?.isQuiteHours || showQuietHours ? "URL" : "Text",
  //     });
  //     window.location.replace(priceQuoteRes.link);
  //     window.location.replace(priceQuoteRes.link);
  //   } catch (error) {
  //     console.error("generate price quote error", error);
  //   }
  // };

  const handleViewMyQuote = async () => {
    const clientId = enrolleeUser?.clientId || enrolleeUser?.ClientId;
    const vehicleId =
      enrolleeUser?.vehicleId ||
      enrolleeUser?.VehicleId ||
      enrolleeUser?.selectedVehicleID ||
      null;

    const normalizedDeviceType =
      enrolleeUser?.deviceType === "Portable" ||
      enrolleeUser?.clientTypeId === 5
        ? "PAM"
        : enrolleeUser?.deviceType === "Speed" ||
            enrolleeUser?.deviceType === "ISA" ||
            enrolleeUser?.clientTypeId === 6
          ? "ISA"
          : "IID";

    try {
      await enrolleeUpdate({
        enrolleeId: enrolleeUser?.enrolleeId || enrolleeUser?.EnrolleeId,
        story: "Pricing",
        Step: "Quote",
      });

      let priceQuoteRes = await generatePriceQuote({
        ClientID: clientId,
        VehicleID: vehicleId,
        DeviceType: normalizedDeviceType,
        LocationID: pilotLocation?.locationID,
        ContactMethod:
          enrolleeUser?.isQuiteHours || showQuietHours ? "URL" : "Text",
      });

      window.location.replace(priceQuoteRes.link);
    } catch (error) {
      console.error("generate price quote error", error);
    }
  };

  const handleChatWithAgent = () => {
    setShowGetExpertIcon(false);
    setOpenChatBot((prev) => !prev);
  };

  let QuietHoursInstruction = [
    {
      id: 1,
      title: t("steps.quiteHourTitle1"),
      description1: t("steps.quiteHourDes1"),
      description2: t("steps.quiteHourDes2"),
      type: "Phone",
      phoneNumber: "(855) 221-0171",
      buttonText: t("steps.quiteHourButton1"),
      showChatBot: false,
    },
    {
      id: 2,
      title: t("steps.quoteReady"),
      description1: t("steps.quiteHourDes3"),
      description2: t("steps.quiteHourDes4"),
      type: "text",
      buttonText: t("steps.quiteHourButton2"),
      showChatBot: true,
      clickEvent: handleViewMyQuote,
    },
    {
      id: 3,
      title: t("steps.quiteHourTitle1"),
      description1: t("steps.quiteHourDes12"),
      description2: t("steps.quiteHourDes4"),
      type: "text",
      buttonText: t("steps.quiteHourButton5"),
      showChatBot: false,
      clickEvent: handleChatWithAgent,
    },
  ];

  const {
    UTM_source,
    UTM_medium,
    UTM_campaign,
    GA_clientid,
    gclid,
    UserAgent,
    IPAddress,
    wbraid,
    gbraid,
    fbclid,
    fbp,
    ttclid,
    rdt_cid,
    Page:rawPage,
    URL,
  } = EnrollCookieData;
  const Page = rawPage?.substring(0, 150) || "";
  const contactInfoForm = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      firstName: enrolleeUser?.firstName || enrolleeUser?.FirstName || null,
      lastName: enrolleeUser?.lastName || enrolleeUser?.LastName || null,
      cellPhone: enrolleeUser?.cellPhone || enrolleeUser?.CellPhone || null,
      email: enrolleeUser?.email || enrolleeUser?.Email,
      preferedContact: null,
      call_me_out: null,
    },
  });

  const handleNext = () => {
    setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
  };

  const handleStepClick = (index) => {
    if (activeStep < steps.length - 1 && index < activeStep) {
      setActiveStep(index);
    }
  };

  useEffect(() => {
    if (isMobile) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [activeStep]);

  useEffect(() => {
    if (!usePricingTextPilot) {
      setIsPilotQuoteReady(false);
      sessionStorage.removeItem("pricingTextPilotQuoteReady");
      sessionStorage.removeItem("pricingTextPilotClientId");
    }
  }, [usePricingTextPilot]);

  const formatTime = (seconds) => {
    const min = String(Math.floor(seconds / 60)).padStart(2, "0");
    const sec = String(seconds % 60).padStart(2, "0");
    return `${min}:${sec}`;
  };

  const formatClockTime = (date) => {
    return new Date(date).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  useEffect(() => {
    if (usePricingTextPilot) {
      return;
    }

    if (isPAM ? activeStep === 3 : activeStep === 4) {
      let storedStartTime = sessionStorage.getItem("startTimer");
      let timerStartTime;

      if (!storedStartTime) {
        timerStartTime = new Date();
        sessionStorage.setItem("startTimer", timerStartTime.toISOString());
      } else {
        timerStartTime = new Date(storedStartTime);
      }

      setStartTime(timerStartTime);

      const currentTime = new Date();
      const elapsedSeconds = Math.floor((currentTime - timerStartTime) / 1000);
      const remaining = 300 - elapsedSeconds;

      setSecondsLeft(remaining > 0 ? remaining : 0);

      let remainingTimeData = {
        isTimeRemaining: remaining < 0 || remaining === 0,
      };
      sessionStorage.setItem(
        "buildQuoteStep",
        JSON.stringify({ ...buildQuoteStep, ...remainingTimeData }),
      );

      const interval = setInterval(() => {
        const now = new Date();
        const elapsed = Math.floor((now - timerStartTime) / 1000);
        const remainingTime = 300 - elapsed;

        setSecondsLeft(remainingTime > 0 ? remainingTime : 0);
        let remainingTimeData = {
          isTimeRemaining: remainingTime < 0 || remainingTime === 0,
        };
        sessionStorage.setItem(
          "buildQuoteStep",
          JSON.stringify({ ...buildQuoteStep, ...remainingTimeData }),
        );

        if (remainingTime <= 0) clearInterval(interval);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [activeStep, isPAM, usePricingTextPilot]);

  useEffect(() => {
    if (isEnrolleeLoadNeeded === true) {
      const reloadEnrollee = async () => {
        const currentEnrolleeUser =
          JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
        const resolvedClientId =
          currentEnrolleeUser?.clientId || currentEnrolleeUser?.ClientId;
        const resolvedUserId =
          currentEnrolleeUser?.userId || currentEnrolleeUser?.UserId;

        if (resolvedClientId !== undefined && resolvedUserId !== undefined) {
          try {
            const enrolleeData = await loadEnrollee(
              resolvedClientId,
              resolvedUserId,
            );

            if (enrolleeData) {
              setEnrolleeUserSession({
                ...currentEnrolleeUser,
                ...enrolleeData,
              });

              if (enrolleeData?.contactPreference) {
                setPreferedContact(enrolleeData?.contactPreference);
              }
            }
          } catch (error) {
            console.log(error);
          } finally {
            setIsEnrolleeLoadNeeded(false);
          }
        }
      };

      reloadEnrollee();
    }
  }, [isEnrolleeLoadNeeded]);

  const handleUpdate = async (currentStep, updateData) => {
    if (currentStep === "Referral") {
      handleReferalSubmit();
      return;
    }

    setSubmitting(true);
    const currentEnrolleeUser =
      JSON.parse(sessionStorage.getItem("enrolleeUser")) || enrolleeUser || {};
    const enrolleeID =
      currentEnrolleeUser?.enrolleeId ||
      currentEnrolleeUser?.EnrolleeId ||
      enrolleeUser?.enrolleeId ||
      enrolleeUser?.EnrolleeId;
    const userId =
      currentEnrolleeUser?.userId ||
      currentEnrolleeUser?.UserId ||
      enrolleeUser?.userId ||
      enrolleeUser?.UserId;
    const jwtToken = jwtTokenData?.jwtToken;
    const clientId =
      currentEnrolleeUser?.clientId ||
      currentEnrolleeUser?.ClientId ||
      enrolleeUser?.clientId ||
      enrolleeUser?.ClientId;
    try {
      if (enrolleeID && jwtToken) {
        const enrolleData = {
          ...updateData,
          enrolleeId: enrolleeID,
          story: "Pricing",
          Step: currentStep,
          contactPreference: pereferedContact || "Phone",
          deviceType:
            resolveDeviceTypeValue(
              updateData?.deviceType,
              currentEnrolleeUser?.deviceType,
              currentEnrolleeUser?.clientTypeId,
              currentEnrolleeUser?.ClientTypeId,
              enrolleeUser?.deviceType,
              enrolleeUser?.clientTypeId,
              enrolleeUser?.ClientTypeId,
            ) || "Interlock",
          utM_source: UTM_source || null,
          utM_medium: UTM_medium || null,
          utM_campaign: UTM_campaign || null,
          gA_clientid: GA_clientid || null,
          gclID: gclid,
          userAgent: UserAgent || null,
          ipAddress: IPAddress || null,
          wbraid: wbraid || null,
          gbraid: gbraid || null,
          fbclid: fbclid || null,
          fbp: fbp || null,
          ttclid: ttclid || null,
          rdt_cid: rdt_cid || null,
          page: Page || null,
          referURL: URL?.slice(0, 500) || null,
        };
        await enrolleeUpdate(enrolleData);
      }

      if (updateData?.isReferralModalSubmit && clientId) {
        const referralSessionData =
          JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
        const referralClientUpdate = {
          ...referralSessionData,
          ...updateData,
          ClientId: clientId,
          UserId: userId,
          EnrolleeId: enrolleeID,
          BrandIdentifier:
            updateData?.BrandIdentifier ||
            referralSessionData?.BrandIdentifier ||
            brand,
          CellPhone:
            updateData?.CellPhone ||
            referralSessionData?.CellPhone ||
            referralSessionData?.cellPhone ||
            null,
          HomePhone:
            updateData?.HomePhone ||
            referralSessionData?.HomePhone ||
            referralSessionData?.homePhone ||
            null,
          Email:
            updateData?.Email ||
            referralSessionData?.Email ||
            referralSessionData?.email ||
            null,
          FirstName:
            updateData?.FirstName ||
            referralSessionData?.FirstName ||
            referralSessionData?.firstName ||
            null,
          LastName:
            updateData?.LastName ||
            referralSessionData?.LastName ||
            referralSessionData?.lastName ||
            null,
          contactPreference: pereferedContact || "Phone",
          story: "Pricing",
        };
        await clientUpdate(referralClientUpdate);
      }

      switch (currentStep) {
        case "Contact":
          try {
            const storedContactSessionData =
              JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
            const preservedContactFields = {
              HearAboutID:
                updateData?.HearAboutID ??
                storedContactSessionData?.HearAboutID ??
                null,
              HearAboutName:
                updateData?.HearAboutName ??
                storedContactSessionData?.HearAboutName ??
                null,
            };

            if (!enrolleeID || !jwtToken) {
              const contactUpdateData = {
                ...preservedContactFields,
                ...updateData,
              };

              await registerEnrollee(contactUpdateData).then(
                async (enrolleeRes) => {
                  cookies.set(
                    "lifesaferEnrollment",
                    JSON.stringify(enrolleeRes),
                    {
                      path: "/",
                      sameSite: "strict",
                    },
                  );
                  let enrolleeData = {
                    ...contactUpdateData,
                    enrolleeId: enrolleeRes?.enrolleeId,
                    clientId: enrolleeRes?.clientId,
                    story: "Pricing",
                    Step: currentStep,
                    utM_source: UTM_source || null,
                    utM_medium: UTM_medium || null,
                    utM_campaign: UTM_campaign || null,
                    gA_clientid: GA_clientid || null,
                    gclID: gclid || null,
                    userAgent: UserAgent || null,
                    ipAddress: IPAddress || null,
                    wbraid: wbraid || null,
                    gbraid: gbraid || null,
                    fbclid: fbclid || null,
                    fbp: fbp || null,
                    ttclid: ttclid || null,
                    rdt_cid: rdt_cid || null,
                    page: Page || null,
                    referURL: URL?.slice(0, 500) || null,
                  };
                  if (!enrolleeRes?.jwtToken) {
                    setEnrolleeUserSession(enrolleeRes);

                    if (["TEXT", "EMAIL"].includes(enrolleeRes?.resetSent)) {
                      shouldSkipNextStep = true;
                      return navigate("/verify", {
                        state: {
                          enrollee: enrolleeRes,
                          lifeSaferUser: contactUpdateData,
                        },
                      });
                    }

                    if (enrolleeRes?.resetSent === "CALL") {
                      shouldSkipNextStep = true;
                      return navigate("/contact-page");
                    }
                  }
                  await enrolleeUpdate(enrolleeData);
                  let clientSaveUpdateData = {
                    ...contactUpdateData,
                    UserId: enrolleeRes?.userId,
                    EnrolleeId: enrolleeRes?.enrolleeId,
                  };
                  if (
                    !utilities.isMissingOrDefaultEnrollmentCode(
                      enrollmentCodeData,
                    )
                  ) {
                    clientSaveResponse =
                      await saveEnrollee(clientSaveUpdateData);
                  }

                  let enrolleeSessionUpdateData = {
                    userId: enrolleeRes?.userId,
                    enrolleeId: enrolleeRes?.enrolleeId,
                    clientId: clientSaveResponse?.clientId,
                    Step: currentStep,
                    story: "Pricing",
                  };

                  enrolleeSessionUpdateData = {
                    ...enrolleeSessionUpdateData,
                    ...contactUpdateData,
                  };

                  setEnrolleeUserSession({ ...enrolleeSessionUpdateData });
                },
              );
            } else {
              const contactUpdateData = {
                ...preservedContactFields,
                ...updateData,
              };

              let clientUpdateData = {
                ...contactUpdateData,
                UserId: userId,
                EnrolleeId: enrolleeID,
                ClientId: clientId,
                Step: currentStep,
                story: "Pricing",
              };

              updateData = {
                ...contactUpdateData,
                UserId: userId,
                EnrolleeId: enrolleeID,
                ClientId: clientId,
                ...{ story: "Pricing" },
              };
              const sessionUpdateData = { ...updateData };
              delete sessionUpdateData.isReferralModalSubmit;

              setEnrolleeUserSession({
                ...currentEnrolleeUser,
                ...sessionUpdateData,
              });

              if (clientId) {
                await clientUpdate(clientUpdateData);
              }
            }

            setReferralModal(updateData?.isReferralModalSubmit ? false : true);
          } catch (error) {
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return;
          }

          break;

        case "Vehicle":
          // await saveNewVehicle(updateData);
          try {
            let newData = {
              vehicleCheckPoint: true,
            };
            sessionStorage.setItem(
              "buildQuoteStep",
              JSON.stringify({ ...buildQuoteStep, ...newData }),
            );

            if (!updateData) {
              break;
            }
            const result = await saveNewVehicle(updateData);
            if (result) {
              const vehicleData = await loadVehicle(
                enrolleeUser?.clientId || enrolleeUser?.ClientId,
                enrolleeUser?.userId || enrolleeUser?.UserId,
              );

              const normalizedResult = String(result);
              const matchedVehicle = vehicleData?.find((x) => {
                const candidateId = x?.vehicleId || x?.VehicleId;
                return String(candidateId) === normalizedResult;
              });

              if (matchedVehicle) {
                const vehicleWithoutUserId = { ...matchedVehicle };
                delete vehicleWithoutUserId.userId;
                setEnrolleeUserSession({
                  ...enrolleeUser,
                  ...updateData,
                  ...vehicleWithoutUserId,
                });
              } else {
                setEnrolleeUserSession({
                  ...enrolleeUser,
                  ...updateData,
                  vehicleId: result,
                  VehicleId: result,
                });
              }
            }
          } catch (error) {
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return;
          }
          break;

        case "Violation":
          try {
            const storedEnrolleeUser =
              JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
            const referralFields = {
              HearAboutID:
                storedEnrolleeUser?.HearAboutID ?? updateData?.HearAboutID,
              HearAboutName:
                storedEnrolleeUser?.HearAboutName ?? updateData?.HearAboutName,
            };

            if (!clientId) {
              if (
                utilities.isMissingOrDefaultEnrollmentCode(enrollmentCodeData)
              ) {
                let contactInfoFormValue = contactInfoForm.watch();
                let newContactInfoData = {
                  Step: "Violation",
                  firstName: contactInfoFormValue.firstName,
                  lastName: contactInfoFormValue.lastName,
                  homePhone: contactInfoFormValue.cellPhone,
                  email: contactInfoFormValue.email,
                  contactPreference: pereferedContact || "Phone",
                  BrandIdentifier: brand,
                  // EnrollmentCodeId:
                  //   // enrolleeUser?.enrollmentCodeId ||
                  //   enrollmentCodeData?.enrollmentCodeId,
                  CellPhone: contactInfoFormValue.cellPhone,
                  // deviceType: deviceType || "IID",
                  EnrolleeId: enrolleeUser?.enrolleeId,
                };

                updateData = {
                  ...updateData,
                  ...newContactInfoData,
                };
              }

              await saveEnrollee(updateData).then(async (enrolleeResponse) => {
                let newData = {
                  ...referralFields,
                  ...updateData,
                  clientId:
                    enrolleeResponse?.ClientId || enrolleeResponse?.clientId,
                  userId: enrolleeResponse?.UserId || enrolleeResponse?.userId,
                  contactPreference: pereferedContact || "Phone",
                  story: "Pricing",
                };

                await clientUpdate(newData);
                const currentEnrolleeUser =
                  JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
                const enrolleeSessionUpdateData = {
                  userId: enrolleeResponse?.UserId || enrolleeResponse?.userId,
                  enrolleeId:
                    enrolleeResponse?.EnrolleeId ||
                    enrolleeResponse?.enrolleeId,
                  clientId:
                    enrolleeResponse?.ClientId || enrolleeResponse?.clientId,
                  Step: "Violation",
                  story: "Pricing",
                  contactPreference: pereferedContact || "Phone",
                };

                setEnrolleeUserSession({
                  ...currentEnrolleeUser,
                  ...updateData,
                  ...newData,
                  ...enrolleeSessionUpdateData,
                });

                if (
                  utilities.isMissingOrDefaultEnrollmentCode(
                    enrollmentCodeData,
                  )
                ) {
                  setEnrolleeUserSession({
                    ...JSON.parse(sessionStorage.getItem("enrolleeUser")),
                    enrollmentCode: updateData?.enrollmentCode,
                    enrollmentCodeId: updateData?.enrollmentCodeId,
                  });

                  let enrolleeCodeData = {
                    enrollmentCode: updateData?.enrollmentCode,
                    enrollmentCodeId: updateData?.enrollmentCodeId,
                  };

                  cookies.set(
                    "lsEnrollmentCode",
                    { ...enrollmentCodeData, ...enrolleeCodeData },
                    {
                      path: "/",
                      sameSite: "strict",
                    },
                  );
                }
              });
            } else {
              updateData = {
                ...referralFields,
                ...updateData,
                contactPreference: pereferedContact || "Phone",
                story: "Pricing",
              };

              let enrolleeCodeData = {
                enrollmentCode: updateData?.enrollmentCode,
                enrollmentCodeId: updateData?.enrollmentCodeId,
              };
              cookies.set(
                "lsEnrollmentCode",
                { ...enrollmentCodeData, ...enrolleeCodeData },
                {
                  path: "/",
                  sameSite: "strict",
                },
              );
              await clientUpdate(updateData);
            }
            const resolvedDeviceType = resolveDeviceTypeValue(
              updateData?.deviceType,
              storedEnrolleeUser?.deviceType,
              storedEnrolleeUser?.clientTypeId,
              storedEnrolleeUser?.ClientTypeId,
              enrolleeUser?.deviceType,
              enrolleeUser?.clientTypeId,
              enrolleeUser?.ClientTypeId,
            );
            setDeviceNeeded(resolvedDeviceType || updateData?.deviceType);
            setShowVehicleStep(
              (resolvedDeviceType || updateData?.deviceType) == "Portable"
                ? false
                : true,
            );
          } catch (error) {
            let errMess = error.message;
            errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
            toast.error(errMess);
            return;
          }

          break;

        case "Build":
          break;

        default:
          console.warn(`Unknown step "${currentStep}"`);
      }
      hasSetInitialStep.current = true;
      if (
        !(
          currentStep === "Contact" &&
          utilities.isMissingOrDefaultEnrollmentCode(enrollmentCodeData)
        )
      ) {
        setIsEnrolleeLoadNeeded(true);
      }
      if (currentStep === "Contact") {
        if (shouldSkipNextStep) {
          return;
        }

        if (updateData?.isReferralModalSubmit) {
          goToNextStep();
        }
        return;
      }
      if (!shouldSkipNextStep) {
        goToNextStep();
      }
    } catch (error) {
      let errMess = error.message
        ?.split(":")
        .pop()
        ?.replace('"', "")
        ?.slice(0, -2);
      toast.error(t("toasts.updateFailed") + " " + errMess);
    } finally {
      setSubmitting(false);
    }
  };

  const goToNextStep = () => {
    // this comment is needed
    // let currentStepIndex = pricingSteps.indexOf(currentStep);
    // if (currentStepIndex >= 0 && pricingSteps[currentStepIndex + 1]) {
    //   setStep(pricingSteps[currentStepIndex + 1]);
    // }

    // if (currentStep == "Contact") {
    //   setActiveStep(2);
    // }
    setActiveStep(activeStep + 1);
  };

  const handlePilotLocationSelected = async ({ location, googleLocation }) => {
    setSubmitting(true);
    try {
      const clientId = enrolleeUser?.clientId || enrolleeUser?.ClientId;
      const userId = enrolleeUser?.userId || enrolleeUser?.UserId;
      const enrolleeId = enrolleeUser?.enrolleeId || enrolleeUser?.EnrolleeId;
      const vehicleId =
        enrolleeUser?.vehicleId ||
        enrolleeUser?.VehicleId ||
        enrolleeUser?.selectedVehicleID ||
        null;
      const normalizedDeviceType =
        enrolleeUser?.deviceType === "Portable" ||
        enrolleeUser?.clientTypeId === 5
          ? "PAM"
          : enrolleeUser?.deviceType === "Speed" ||
              enrolleeUser?.deviceType === "ISA" ||
              enrolleeUser?.clientTypeId === 6
            ? "ISA"
            : "IID";
      const longnormalizedDeviceType =
        enrolleeUser?.deviceType === "Portable" ||
        enrolleeUser?.clientTypeId === 5
          ? "Portable"
          : enrolleeUser?.deviceType === "Speed" ||
              enrolleeUser?.deviceType === "ISA" ||
              enrolleeUser?.clientTypeId === 6
            ? "Speed"
            : "Interlock";

      setPilotLocation(location);

      const locationPayload = {
        ...enrolleeUser,
        clientId: clientId,
        userId: userId,
        EnrolleeId: enrolleeId,
        city: googleLocation?.city || null,
        county: googleLocation?.county || null,
        country: utilities.normalizeCountryForPlus(
          googleLocation?.country,
          "USA",
        ),
        state: googleLocation?.state || null,
        zip: googleLocation?.zip || null,
        homeLat: googleLocation?.homeLat || null,
        homeLong: googleLocation?.homeLong || null,
        locationID: location?.locationID || null,
        locationName: location?.displayName || null,
        story: "Pricing",
        deviceType: longnormalizedDeviceType,
        Step: "Vehicle",
      };

      await clientUpdate(locationPayload);

      await generatePriceQuote({
        ClientID: clientId,
        VehicleID: vehicleId,
        DeviceType: normalizedDeviceType,
        LocationID: location?.locationID || null,
        ContactMethod:
          enrolleeUser?.isQuiteHours || showQuietHours ? "URL" : "Text",
      });

      setEnrolleeUserSession({
        ...enrolleeUser,
        ...locationPayload,
      });
      sessionStorage.setItem("pricingTextPilotQuoteReady", "1");
      sessionStorage.setItem(
        "pricingTextPilotClientId",
        String(clientId || ""),
      );
      setIsPilotQuoteReady(true);
      setIsEnrolleeLoadNeeded(true);
      setShowGeneratingQuoteMessage(false);
    } catch (error) {
      const errMess = error.message
        ?.split(":")
        .pop()
        ?.replace('"', "")
        ?.slice(0, -2);
      toast.error(errMess || t("toasts.updateFailed"));
    } finally {
      setSubmitting(false);
      setShowGeneratingQuoteMessage(false);
    }
  };

  const goToBackStep = () => {
    // this comment is needed
    // let currentStepIndex = pricingSteps.indexOf(step);
    // if (currentStepIndex >= 0 && pricingSteps[currentStepIndex - 1]) {
    //   setStep(pricingSteps[currentStepIndex - 1]);
    // }
    if (activeStep > 0) {
      let pamCondition = isPAM ? 3 : 4;
      if (activeStep === pamCondition) {
        sessionStorage.removeItem("startTimer");
      }
      setActiveStep(activeStep - 1);
    }
  };

  const GeneratingQuote = () => {
    useEffect(() => {
      const timer = setTimeout(() => {
        setShowGeneratingQuoteMessage(false);
      }, 3000);

      return () => clearTimeout(timer);
    }, []);

    return (
      <>
        <br />
        <Grid
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <GridLoader />
          <span style={{ marginTop: "10px" }}>
            {t("steps.generatingQuote")}
          </span>
        </Grid>
      </>
    );
  };

  const renderStepContent = (stepName) => {
    switch (stepName) {
      case "Welcome":
        return (
          <Grid>
            <Typography>{t("steps.welcomeMessage")}</Typography>
            <Welcome />
          </Grid>
        );
      case "Contact":
        return (
          <Grid>
            <StepperText>
              <Typography sx={{ maxWidth: "632px" }}>
                {t("steps.aboutMessage")}
              </Typography>
            </StepperText>
            <ContactInfo
              submitting={submitting}
              handleUpdate={handleUpdate}
              setSubmitting={setSubmitting}
              goToBackStep={goToBackStep}
              contactInfoForm={contactInfoForm}
              pereferedContact={pereferedContact}
              setPreferedContact={setPreferedContact}
            />
          </Grid>
        );
      case "Violation":
        return (
          <Grid>
            <StepperText>
              <Typography sx={{ maxWidth: "632px" }}>
                {t("steps.stateMessage")}
              </Typography>
            </StepperText>
            <ViolationInfo
              submitting={submitting}
              handleUpdate={handleUpdate}
              setSubmitting={setSubmitting}
              goToBackStep={goToBackStep}
            />
          </Grid>
        );
      case "Vehicle":
        return (
          <VehicleInfos
            submitting={submitting}
            handleUpdate={handleUpdate}
            goToBackStep={goToBackStep}
            goToNextStep={goToNextStep}
          />
        );
      case "Build My Quote":
        return (
          <Grid>
            {usePricingTextPilot ? (
              isPilotQuoteReady ? (
                enrolleeUser?.isQuiteHours || showQuietHours ? (
                  <QuietHours
                    setOpenChatBot={setOpenChatBot}
                    openChatBot={openChatBot}
                    pereferedContact={pereferedContact}
                    QuietHoursInstruction={QuietHoursInstruction}
                    enrolleeUser={enrolleeUser}
                    t={t}
                    showGetExpertIcon={showGetExpertIcon}
                  />
                ) : (
                  <PilotQuoteReady />
                )
              ) : (
                <>
                  {submitting === true ? (
                    <>
                      <Grid
                        container
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <Grid>
                          {showGeneratingQuoteMessage ? (
                            <GeneratingQuote />
                          ) : (
                            <GridLoader />
                          )}
                        </Grid>
                      </Grid>
                    </>
                  ) : (
                    <PricingTextPilotLocationStep
                      isLoaded={isLoaded}
                      enrolleeUser={enrolleeUser}
                      submitting={submitting}
                      onLocationSelected={handlePilotLocationSelected}
                    />
                  )}
                </>
              )
            ) : (enrolleeUser?.hasSeenBuildQuote ||
                secondsLeft == 0 ||
                buildQuoteStep?.isTimeRemaining ||
                (enrolleeUser?.story?.toLowerCase() === "pricing" &&
                  enrolleeUser?.step?.toLowerCase() === "vehicle" &&
                  !buildQuoteStep?.vehicleCheckPoint)) &&
              !(enrolleeUser?.isQuiteHours || showQuietHours) ? (
              <Ready />
            ) : showQuietHours || enrolleeUser?.isQuiteHours ? (
              <QuietHours
                setOpenChatBot={setOpenChatBot}
                openChatBot={openChatBot}
                pereferedContact={pereferedContact}
                QuietHoursInstruction={QuietHoursInstruction}
                enrolleeUser={enrolleeUser}
                t={t}
                showGetExpertIcon={showGetExpertIcon}
              />
            ) : (
              <BuildYourQuote sx={{ width: "100%" }} />
            )}
          </Grid>
        );
      default:
        return null;
    }
  };
  const Welcome = () => {
    return (
      <Grid sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant="contained"
          onClick={() => handleNext()}
          sx={{
            backgroundColor: `${brandColors[brand].secondary}`,
            fontWeight: "bold",
          }}
          endIcon={<VerifiedIcon />}
        >
          {t("steps.startMyQuote")}
        </Button>
      </Grid>
    );
  };

  const BuildYourQuote = () => {
    return (
      <>
        <Grid
          container
          spacing={{ lg: 4, md: 2 }}
          alignItems={"center"}
          sx={{
            mt: 2,
            width: { xl: "80%", lg: "80%", sm: "100%" },
            mx: isMobile ? "" : "auto",
          }}
        >
          <Grid size={{ xl: 9, lg: 10 }}>
            {!isMobile && (
              <Typography
                style={{
                  fontWeight: "900",
                  fontSize: "22px",
                  color: "#1c355e",
                }}
              >
                {t("steps.buildQuoteSuccess")}
              </Typography>
            )}
            {t("steps.buildCodeMessage1")}
            <br />
            <br />
            {t("steps.buildCodeMessage2")}
            {isMobile && (
              <>
                <br />
              </>
            )}{" "}
            {/* <br /> */}
            {t("steps.buildCodeMessage3", {
              ContactPreference: enrolleeUser?.contactPreference || "",
            })}
            <br />
            <br />
            {t("steps.buildCodeMessage4")}
          </Grid>
          <Grid size={{ xl: 3, lg: 2 }}>
            {activeStep === steps.length - 1 && !isMobile && (
              <Timer secondsLeft={secondsLeft} />
            )}
          </Grid>
        </Grid>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            type="submit"
            size="small"
            variant="contained"
            // color="primary"
            startIcon={<PhoneIphoneIcon />}
            style={{
              height: 35,
              width: "max-content",
              marginTop: "20px",
              marginBottom: "20px",
              paddingLeft: "24px",
              paddingRight: "24px",
              fontWeight: "bold",
              backgroundColor: `${brandColors[brand].secondary}`,
            }}
            component="a"
            href={`tel:${phoneNumber}`}
          >
            {phoneNumber}
          </Button>
        </Grid>
        <Grid
          container
          my={2}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Link
            underline="none"
            href={
              isISA
                ? "https://www.lifesaferisa.com"
                : referralSiteData || "https://www.lifesafer.com/"
            }
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              paddingLeft: "20px",
              paddingRight: "20px",
            }}
          >
            <HistoryIcon
              style={{
                fontWeight: "bold",
                color: `${brandColors[brand].primary}`,
              }}
            />
            <Typography
              style={{
                fontWeight: "900",
                color: `${brandColors[brand].primary}`,
                textTransform: "uppercase",
                width: "270px",
              }}
            >
              {/* {t("navigation.returnTo")} {t("navigation.lifesafer")} */}

              {isISA
                ? `${t("navigation.returnTo")} ${t("navigation.lifesaferisa")}`
                : `${t("navigation.returnTo")} ${t("navigation.lifesafer")}`}
            </Typography>
          </Link>
        </Grid>
      </>
    );
  };

  const Ready = () => {
    return (
      <>
        <Grid
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            gap: 3,
            mt: 3,
          }}
        >
          <Grid
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Typography
              sx={{
                fontWeight: "900",
                fontSize: "22px",
                color: "#1c355e",
                width: {
                  xs: "98%",
                  md: "34%",
                },
              }}
            >
              {t("steps.buildAQuoteReadyTitle")}
            </Typography>
            <Typography
              sx={{
                width: {
                  xs: "97%",
                  md: "34%",
                },
                mt: 3,
              }}
            >
              {t("steps.buildAQuoteReadyDescription")}
            </Typography>
          </Grid>
          <Grid>
            <Button
              type="submit"
              size="small"
              variant="contained"
              // color="primary"
              startIcon={<PhoneIphoneIcon />}
              style={{
                height: 35,
                width: "max-content",
                marginTop: "14px",
                marginBottom: "20px",
                paddingLeft: "24px",
                paddingRight: "24px",
                fontWeight: "bold",
                backgroundColor: `${brandColors[brand].secondary}`,
              }}
              component="a"
              href={`tel:${phoneNumber}`}
            >
              {phoneNumber}
            </Button>
          </Grid>
        </Grid>
      </>
    );
  };

  const PilotQuoteReady = () => {
    return (
      <Grid
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          gap: 3,
          mt: 3,
        }}
      >
        <Grid
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Typography
            sx={{
              fontWeight: "900",
              fontSize: "22px",
              color: "#1c355e",
              width: {
                xs: "98%",
                md: "34%",
              },
            }}
          >
            {t("steps.buildAQuoteReadyTitlePilot")}
          </Typography>
          <Typography
            sx={{
              width: {
                xs: "97%",
                md: "34%",
              },
              mt: 3,
            }}
          >
            {t("steps.quoteOnWayTextMessage")}
          </Typography>
        </Grid>
        <Grid>
          <Button
            type="submit"
            size="small"
            variant="contained"
            startIcon={<PhoneIphoneIcon />}
            style={{
              height: 35,
              width: "max-content",
              marginTop: "14px",
              marginBottom: "20px",
              paddingLeft: "24px",
              paddingRight: "24px",
              fontWeight: "bold",
              backgroundColor: `${brandColors[brand].secondary}`,
            }}
            component="a"
            href={`tel:${phoneNumber}`}
          >
            {phoneNumber}
          </Button>
        </Grid>
      </Grid>
    );
  };

  const Timer = () => {
    return (
      <Grid
        sx={{
          mt: 2,
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          backgroundColor: `${brandColors[brand].primaryLight}`,
          // maxWidth: "180px",
          // minWidth: "180px",

          maxWidth:
            i18n?.language == "es" ? (isMobile ? "170px" : "245px") : "180px",
          minWidth:
            i18n?.language == "es" ? (isMobile ? "170px" : "245px") : "180px",
          color: "#fff",
          borderRadius: "10px",
        }}
      >
        <Grid
          sx={{
            padding: "10px",
            display: "flex",
            flexDirection: "column",
            gap: "15px",
          }}
        >
          <Typography
            sx={{
              fontWeight: "bold",
              textAlign: "center",
              fontSize:
                i18n?.language == "es" ? (isMobile ? "20px" : "24px") : "24px",
            }}
            variant="h5"
          >
            {t("steps.twentyfiveoff")}
          </Typography>
          <Grid
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <AccessTimeIcon sx={{ fontSize: "2.125rem" }} />
            <Typography variant="h4" sx={{ fontWeight: "bold" }}>
              {formatTime(secondsLeft)}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          sx={{
            backgroundColor: `${brandColors[brand].primary}`,
            p: 1,
            borderBottomLeftRadius: "10px",
            borderBottomRightRadius: "10px",
          }}
        >
          <Typography sx={{ color: "#fff", textAlign: "center" }}>
            {t("steps.start")}:{" "}
            {startTime ? formatClockTime(startTime) : "--:--"}
          </Typography>
        </Grid>
      </Grid>
    );
  };

  let pamCondition = isPAM ? 3 : 4;

  return (
    // <Box sx={{ mt: 2 }}>
    <Box sx={{ mb: 6 }}>
      <ReferralModal
        setReferralModal={setReferralModal}
        referralModal={referralModal}
        goToNextStep={goToNextStep}
        handleUpdate={handleUpdate}
        pereferedContact={pereferedContact}
        STEPS={STEPS}
        setStepSchedule={setStepSchedule}
        setActiveStep={setActiveStep}
        setFlagDevice={setFlagDevice}
        handleReferalSubmit={handleReferalSubmit}
      />
      <Stepper
        activeStep={activeStep}
        orientation={orientation}
        alternativeLabel={orientation === "horizontal"}
        connector={
          orientation === "horizontal" ? <ColorlibConnector /> : undefined
        }
        sx={{ cursor: activeStep == pamCondition ? "" : "pointer" }}
      >
        {steps.map((stepId, index) => (
          <Step
            key={stepId}
            sx={{
              "& .Mui-completed": { fill: `${brandColors[brand].secondary}` },
            }}
          >
            <StepLabel
              sx={{
                "& .MuiStepLabel-label.Mui-active": {
                  fontWeight: "bold",
                  fontSize: isMobile ? "24px" : "",
                },
              }}
              StepIconComponent={
                orientation === "horizontal" ? ColorlibStepIcon : undefined
              }
              onClick={() => handleStepClick(index)}
            >
              {activeStep === index &&
              activeStep === steps.length - 1 &&
              isMobile ? (
                <>{t("steps.buildQuoteSuccess")}</>
              ) : activeStep === steps.length - 1 && activeStep === index ? (
                <>{t("steps.success")}...</>
              ) : (
                <> {stepLabels ? stepLabels[index] : stepId}</>
              )}
            </StepLabel>
            {orientation === "vertical" && (
              <StepContent>{renderStepContent(stepId)}</StepContent>
            )}
          </Step>
        ))}
      </Stepper>

      {orientation === "horizontal" && activeStep < steps.length && (
        <Box sx={{ mt: 3 }}>
          <Grid container>
            <Grid
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                px: isTablet ? 2 : 2,
                width: "100%",
              }}
            >
              {renderStepContent(steps[activeStep])}
            </Grid>
            {/* <Grid sx={{ width: "100%" }}>
              {activeStep === steps.length - 1 && (
                <Grid
                  sx={{
                    position: "absolute",
                    right: "20px",
                    top: isMobile ? "15%" : "80%",
                  }}
                >
                  <Timer secondsLeft={secondsLeft} />
                </Grid>
              )}
            </Grid> */}
          </Grid>
        </Box>
      )}

      {activeStep === steps.length - 1 &&
        isMobile &&
        !usePricingTextPilot &&
        !showQuietHours &&
        !enrolleeUser?.hasSeenBuildQuote &&
        !enrolleeUser?.isQuiteHours && (
          <Grid
            sx={{
              position: isMobile ? "absolute" : "relative",
              right: i18n?.language === "es" ? "8px" : "20px",
              top: isMobile ? (i18n?.language === "es" ? "7%" : "8%") : "20%",
            }}
          >
            {enrolleeUser?.hasSeenBuildQuote ||
              secondsLeft == 0 ||
              buildQuoteStep?.isTimeRemaining ||
              (enrolleeUser?.story?.toLowerCase() === "pricing" &&
              enrolleeUser?.step?.toLowerCase() === "vehicle" &&
              !buildQuoteStep?.vehicleCheckPoint ? (
                <></>
              ) : (
                <Timer secondsLeft={secondsLeft} />
              ))}
          </Grid>
        )}
    </Box>
  );
};

function mapStateToProps() {
  return {};
}

const mapDispatchToProps = {
  registerEnrollee,
  enrolleeUpdate,
  saveEnrollee,
  clientUpdate,
  generatePriceQuote,
  saveNewVehicle,
  loadEnrollee,
  loadVehicle,
  GetQuietHours,
};

PricingStory.propTypes = {
  referralSiteData: PropTypes.string,
  registerEnrollee: PropTypes.func,
  enrolleeUpdate: PropTypes.func,
  saveEnrollee: PropTypes.func,
  clientUpdate: PropTypes.func,
  steps: PropTypes.array,
  stepLabels: PropTypes.array,
  activeStep: PropTypes.number,
  setActiveStep: PropTypes.func,
  saveNewVehicle: PropTypes.func,
  loadEnrollee: PropTypes.func,
  hasSetInitialStep: PropTypes.bool,
  loadVehicle: PropTypes.func,
  setDeviceNeeded: PropTypes.func,
  setShowVehicleStep: PropTypes.func,
  phoneNumber: PropTypes.string,
  isLoaded: PropTypes.bool,
  generatePriceQuote: PropTypes.func,
  GetQuietHours: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingStory);
